import { IsBlacklisted, Unsuppress } from "../../api/suppressionService";
import { SuppressionCheckForm } from "./SuppressionCheckForm";
import { useSuppressionCheck } from "./useSuppressionCheck";

export function BlacklistCheck() {
  const check = useSuppressionCheck({
    check: IsBlacklisted,
    remove: Unsuppress,
    isListed: (data) => Boolean(data.IsBlacklisted),
    checkFailedMessage: "Error checking blacklist",
    removeFailedMessage: "Error removing blacklist",
    listedMessage: (email) => `${email} is currently being suppressed`,
    notListedMessage: (email) => `${email} is currently not being suppressed`,
    removedMessage: (email) =>
      `${email} has been successfully removed from the suppression list`,
    notRemovedMessage: (email) =>
      `Unable to remove ${email} from the suppression list`,
  });

  return (
    <SuppressionCheckForm
      name="blacklistEmailAddress"
      check={check}
      checkText="Check Blacklist"
      removeText="Unsuppress"
    />
  );
}
